import { ErrorMessage, Field, Formik } from 'formik'
import { AvatarSelector, ModalForm, ReactSelectStyled } from 'modules/app/styles'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Col, FormGroup, Input, Label, ModalBody, Row } from 'reactstrap'
import * as yup from 'yup'
import { ReactComponent as SharpIcon } from 'assets/images/icons/sharp.svg'
import { ReactComponent as CloseIcon } from 'assets/images/icons/close.svg'
import { getGICountryCodes_api, updateCompany_api } from 'store/apis'
import { CustomButton } from 'modules/auth/styles'
import { ButtonLoader } from 'utils/storageUtils'
import { getCompany_action } from 'store/actions'
import { checkImageUploadType, handleApiError, removeMediaFromSpaces, uploadtoSpaces } from 'utils/helpers'

const resetCountry = null

export const GeneralSetting = (props) => {
  const { company } = props
  const [is_submitting, set_is_submitting] = useState(false)
  const [saved, set_saved] = useState(false)
  const [previewAvatar, set_previewAvatar] = useState(company.logo)
  const [avatarFile, set_avatarFile] = useState(null)
  const [countries, set_countries] = useState([])

  const onChangeAvatar = (e) => {
    const file = e.target.files[0]
    if (file && checkImageUploadType(file.type)) {
      var reader = new FileReader()
      reader.onload = (e) => {
        set_previewAvatar(e.target.result)
        set_avatarFile(file)
      }
      reader.readAsDataURL(file)
    } else {
      handleApiError('Invalid image')
    }
  }
  const removePreview = (e) => {
    e.preventDefault()
    set_previewAvatar(null)
    set_avatarFile(null)
    const fileElem = document.querySelector('#avatar')
    if (document.querySelector('#avatar')) {
      fileElem.value = ''
    }
  }

  useEffect(() => {
    const getCountryCodes = async () => {
      try {
        const data = await getGICountryCodes_api()
        set_countries(data.map((c) => ({ value: c.id, label: c.name })))
      } catch (error) {
        handleApiError(error)
      }
    }
    getCountryCodes()
  }, [])

  return (
    <ModalBody>
      <Formik
        enableReinitialize
        initialValues={{
          previewAvatar: previewAvatar,
          logo: previewAvatar,
          name: company.name,
          employee_range: company.employee_range,
          address: company.address,
          city: company.city,
          zip: company.zip,
          vat: company.vat,
          who_can_share: company.who_can_share,
          country: company.country ? countries[countries.map((c) => c.value).indexOf(company.country)] : resetCountry
        }}
        validationSchema={yup.object().shape({
          name: yup.string().required(),
          zip: yup
            .string()
            .nullable()
            .matches(/^[A-Za-z0-9]+$/, 'Invalid input')
            .max(12, 'Must be maximum 12 digits')
        })}
        onSubmit={async (values) => {
          try {
            set_is_submitting(true)
            const data = { ...values, country: values.country && values.country.value ? values.country.value : '' }
            // Uplaod logo if add / changed
            if (avatarFile) {
              // If changed, remove the older one
              if (company.logo) {
                removeMediaFromSpaces(company.logo)
              }
              const link = await uploadtoSpaces(process.env.REACT_APP_DO_SPACES_COMPANY_LOGOS, avatarFile)
              data.logo = link
            }
            // If Logo Removed
            else if (company.logo && !previewAvatar) {
              removeMediaFromSpaces(company.logo)
            }
            delete data.previewAvatar
            await updateCompany_api(data, company.uuid)
            set_saved(true)
            props.getCompany()
          } catch (error) {
            handleApiError(error)
          }
          set_is_submitting(false)
          setTimeout(() => {
            set_saved(false)
          }, 2000)
        }}>
        {(formikProps) => (
          <ModalForm onSubmit={formikProps.handleSubmit} autoComplete='off' style={{ maxWidth: 400 }}>
            <div className='title'>General</div>
            <br />
            <br />
            <FormGroup className='mb-5'>
              <AvatarSelector htmlFor='logo'>
                {formikProps.values.logo && props.user.membership.user_type === 'admin' && (
                  <a href='/' className='remove' onClick={removePreview}>
                    <CloseIcon />
                  </a>
                )}
                <input type='file' name='logo' onChange={onChangeAvatar} id='logo' accept='image/jpeg, image/jpg, image/png' />
                <div className='preview' style={{ borderRadius: '5px' }}>
                  {previewAvatar && <img src={previewAvatar} alt='' style={{ borderRadius: '5px' }} />}
                  {!previewAvatar && <SharpIcon className='placeholder' />}
                </div>
                {!previewAvatar && <div className='upload-logo-placeholder'>Upload Logo</div>}
              </AvatarSelector>
              <div className='text-muted'>
                <small>
                  To show your logo's optimal quality, upload a logo with:
                  <ul className='pl-3' style={{ listStyle: 'disc' }}>
                    <li>PNG format without background</li>
                    <li>72 pixels x 72 pixels resolution</li>
                  </ul>
                </small>
              </div>
            </FormGroup>
            <Field name='name'>
              {({ field }) => (
                <FormGroup className='mb-5'>
                  <Label>Company Name</Label>
                  <Input {...field} className={formikProps.errors.name ? 'error' : ''} disabled={props.user.membership.user_type !== 'admin'} />
                </FormGroup>
              )}
            </Field>
            <Field name='employee_range'>
              {({ field }) => (
                <FormGroup className='mb-5'>
                  <Label>Employee Range</Label>
                  <Input type='select' id='employee_range' {...field} disabled={props.user.membership.user_type !== 'admin'}>
                    <option value=''>Select employee range</option>
                    <option value='1'>Individual</option>
                    <option value='2-20'>2 - 20</option>
                    <option value='21-40'>21 - 40</option>
                    <option value='41-60'>41 - 60</option>
                    <option value='61-80'>61 - 80</option>
                    <option value='80+'>80+</option>
                  </Input>
                </FormGroup>
              )}
            </Field>

            <div className='font-weight-600 text-muted mb-2'>To be used for invoicing:</div>
            <Row>
              <Col xs={12} md={6}>
                <Field name='address'>
                  {({ field }) => (
                    <FormGroup className='mb-5 mb-md-0'>
                      <Label>Address</Label>
                      <Input {...field} className={formikProps.errors.address ? 'error' : ''} disabled={props.user.membership.user_type !== 'admin'} />
                    </FormGroup>
                  )}
                </Field>
              </Col>
              <Col xs={12} md={6}>
                <Field name='city'>
                  {({ field }) => (
                    <FormGroup className='mb-5 mb-md-0'>
                      <Label>City</Label>
                      <Input {...field} className={formikProps.errors.city ? 'error' : ''} disabled={props.user.membership.user_type !== 'admin'} />
                    </FormGroup>
                  )}
                </Field>
              </Col>
            </Row>
            <Row className='mt-md-5'>
              <Col xs={12} md={3}>
                <Field name='zip'>
                  {({ field }) => (
                    <FormGroup className='mb-5'>
                      <Label>Zip</Label>
                      <Input {...field} type='number' className={formikProps.errors.zip ? 'error' : ''} disabled={props.user.membership.user_type !== 'admin'} />
                      <ErrorMessage name='zip'></ErrorMessage>
                    </FormGroup>
                  )}
                </Field>
              </Col>
              <Col xs={12} md={4}>
                <FormGroup className='mb-5 mb-md-0'>
                  <Label>Country</Label>
                  <ReactSelectStyled
                    menuPlacement='top'
                    className='select-control'
                    classNamePrefix='select-control'
                    isClearable
                    value={formikProps.values.country}
                    onChange={(obj) => formikProps.setFieldValue('country', obj || resetCountry)}
                    options={countries || []}
                    placeholder=''
                  />
                </FormGroup>
              </Col>
              <Col xs={12} md={5}>
                <Field name='vat'>
                  {({ field }) => (
                    <FormGroup className='mb-5 mb-md-0'>
                      <Label htmlFor='vat'>VAT</Label>
                      <Input {...field} id='vat' type='number' className={`${formikProps.errors.vat ? 'error' : ''} ${formikProps.values.vat ? 'has-value' : ''}`} />
                    </FormGroup>
                  )}
                </Field>
              </Col>
            </Row>
            {props.user.membership.user_type === 'admin' && (
              <>
                <div className='font-weight-600 text-muted mb-2'>Who can share pages externally:</div>
                <Field name='who_can_share'>
                  {({ field }) => (
                    <FormGroup check className='d-flex align-items-center px-0 mb-5'>
                      <Label check className='mr-4'>
                        <Input
                          {...field}
                          type='radio'
                          name='radio1'
                          checked={formikProps.values.who_can_share === 'admins'}
                          value='admins'
                          onChange={(e) => formikProps.setFieldValue('who_can_share', e.target.value)}
                        />
                        <span>Admins</span>
                      </Label>
                      <Label check>
                        <Input
                          {...field}
                          type='radio'
                          name='radio1'
                          checked={formikProps.values.who_can_share === 'members'}
                          value='members'
                          onChange={(e) => formikProps.setFieldValue('who_can_share', e.target.value)}
                        />
                        <span>All Members</span>
                      </Label>
                    </FormGroup>
                  )}
                </Field>
              </>
            )}
            {props.user.membership.user_type === 'admin' && (
              <CustomButton type='submit' className={`${!saved ? 'black' : 'green'}`} disabled={is_submitting || saved || !formikProps.isValid}>
                {saved ? 'Saved' : 'Update'} {is_submitting && <ButtonLoader />}
              </CustomButton>
            )}
          </ModalForm>
        )}
      </Formik>
    </ModalBody>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  company: state.company.company
})

const mapDispatchToProps = (dispatch) => ({
  getCompany: () => dispatch(getCompany_action())
})

export default connect(mapStateToProps, mapDispatchToProps)(GeneralSetting)
